import { useSelector } from 'react-redux'

import { useTranslate } from '../utils/translate'

// This `ErrorPage` component renders a "blank" error page without navigation, footer and any theme dependent styling.
//
// Up until now, it is used for:
// - 429 rate limit errors (via the `Storefront` and `Editor` components).
//   See EPUI-861 and related PR for explanation.
// - 405 Method Not Allowed errors that are thrown by React Router (via the `ErrorBoundary` component).
// - 403/404 slug validation errors that are thrown in loaders
//
// This is NOT TO BE CONFUSED WITH the `Error` component which renders "normal" error pages for all other errors
// as part of a shop's page with navigation, footer and theme dependent styling.
export default function ErrorPage({
  statusCode,
  requestId = null,
}: Readonly<{
  statusCode: number
  requestId?: string | null
}>) {
  const shop = useSelector<State, ImmutableMap>((state) => state.get('shop'))
  const t = useTranslate('shop')

  return (
    <div className="error-page">
      <section className="section">
        <div className="wrapper">
          <div className="content">
            <h1>{t('views.storefrontView.errorPageSection.errorcode', { code: statusCode })}</h1>
            <div className="error-page-info">
              <h3>{t(`views.storefrontView.errorPageSection.${statusCode === 404 ? 'error404' : 'error500'}`)}</h3>
              {requestId && (
                <p className="error-page-info-explanation">
                  {t('views.storefrontView.errorPageSection.idExplanation')} <code>{requestId}</code>
                </p>
              )}
              <p>
                {/* If this error page is rendered, the website cannot be used. Therefore, navigate with full page loads. */}
                <a href={shop.get('href')} className="error-page-info-link">
                  {t('views.storefrontView.returnToStartpageLink.label')}
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}
